export class Core {
  public values: Values = new Values();
  public checks: Checks = new Checks();
}

export class Values {
  public create_date: string = "";
  public hyoukasya: string = "";
  public pat_name: string = "";
  public total_point: string = "";
}

export class Checks {
  public check_1: boolean = true;
  public check_10: boolean = true;
  public check_11: boolean = false;
  public check_12: boolean = false;
  public check_13: boolean = true;
  public check_14: boolean = false;
  public check_15: boolean = true;
  public check_16: boolean = false;
  public check_17: boolean = false;
  public check_18: boolean = false;
  public check_19: boolean = true;
  public check_2: boolean = false;
  public check_20: boolean = false;
  public check_21: boolean = false;
  public check_22: boolean = true;
  public check_23: boolean = false;
  public check_24: boolean = false;
  public check_25: boolean = true;
  public check_26: boolean = false;
  public check_27: boolean = false;
  public check_28: boolean = true;
  public check_29: boolean = false;
  public check_3: boolean = false;
  public check_30: boolean = false;
  public check_4: boolean = true;
  public check_5: boolean = false;
  public check_6: boolean = false;
  public check_7: boolean = false;
  public check_8: boolean = true;
  public check_9: boolean = false;
}
